var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-table',{ref:"table",staticClass:"role-state-list",attrs:{"url":"/project/role_res","query":_vm.query,"columns":_vm.columns,"show-pagination":false,"response-handler":_vm.responseHandler,"init-search":false,"stripe":"","border":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }